import { TableRow, TableRowProps } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { PinRow } from './FlexTable.component';

const useStyles = makeStyles<Partial<FlexTableRowProps>>()((_theme, { headCellHeight }) => ({
  root: {
    '&[data-pinrow=top]': {
      top: headCellHeight,
      position: 'sticky',
      zIndex: 1000,
    },
    '&[data-pinrow=bottom]': {
      bottom: 0,
      position: 'sticky',
      zIndex: 1000,
    }
  }
}));


export type FlexTableRowProps = TableRowProps & {
  ['data-pinrow']?: PinRow;
  headCellHeight: number;
  testId?: string;
};


export const FlexTableRow: React.FC<FlexTableRowProps> = ({ headCellHeight, testId = 'flex-table-row', ...props }) => {
  const { classes } = useStyles({ headCellHeight });

  return <TableRow {...props} classes={classes} data-testid={testId}/>;
};
